// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Modifier = t.struct({
    firstName: t.String,
    id: t.String,
    lastName: t.String
}, {
    name: 'Modifier',
    strict: true
});

export const getDefaultState = () => new Modifier({
    firstName: '',
    id: '',
    lastName: ''
});

export default Modifier;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/modifier.js